import React from "react";
import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

export default function Footer() {
  const classes = useStyles();
  const [showEmail, setShowEmail] = React.useState(false);

  return (
    <footer className={classes.footer}>
      <Typography variant="body1" color="textPrimary">
        Призвание - Найди занятие по интересам!<br/>
        Сервис поиска занятий в учреждениях дополнительного образования города.<br/>
        <br/>
        &copy; 2020 Булгаков Артём<br/>
      </Typography>
    </footer>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      backgroundColor: "#eeeeee",
      // height: 480,
      padding: theme.spacing(4),
      marginTop: theme.spacing(1)
    }
  })
);